import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'attribute',
    serviceName: 'shopadmin',
    query: gql`
      query attribute(
        $ids: [String]
        $title: String
        $shop_id: String
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        attribute(
          ids: $ids
          title: $title
          shop_id: $shop_id
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteAttribute',
    serviceName: 'admin',
    query: gql`
      mutation deleteAttribute($ids: [String]!) {
        deleteAttribute(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'attribute',
    serviceName: 'admin',
    query: gql`
      query attribute($ids: [String]) {
        attribute(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'attribute',
    serviceName: 'admin',
    query: gql`
      query attribute($ids: [String]) {
        attribute(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
